import { homeOf, isUpright, rowsOf } from './board';
import type { Board, Edge } from './types';

/** 原图相邻 + 当前摆放相邻 + 方向一致 + 两块都正面朝上且没转 */
export function correctEdges(board: Board): Edge[] {
  const { n, pos } = board;
  const rows = rowsOf(board);
  const edges: Edge[] = [];
  for (let t = 0; t < n * rows; t++) {
    const home = homeOf(t, n);
    const p = pos[t];
    if (!isUpright(board, t)) continue;
    if (home.col + 1 < n) {
      const q = pos[t + 1];
      if (q.row === p.row && q.col === p.col + 1 && isUpright(board, t + 1)) edges.push([t, t + 1]);
    }
    if (home.row + 1 < rows) {
      const q = pos[t + n];
      if (q.row === p.row + 1 && q.col === p.col && isUpright(board, t + n)) edges.push([t, t + n]);
    }
  }
  return edges;
}

export const edgeKey = (e: Edge): string => `${e[0]}-${e[1]}`;
